

   <!-- Header -->
   <header id="page-header">
      <!-- Header Content -->
      <div class="content-header">
          <!-- Left Section -->
          <div class="content-header-section">
 

              <!-- Logo -->
              <div class="content-header-item">
                  <a class="link-effect font-w700 mr-5" routerLink="/" tabindex="-1">
                      <i class="si si-fireX text-primary"></i>
                      <span class="font-size-xl text-dual-primary-dark">lectionary</span><span class="font-size-xl text-primary">web</span>
                  </a>
              </div>
              <!-- END Logo -->

              <ul *ngIf="userSvc.isLoggedIn()"  class="nav-main-header nav-main-header-no-icons">

              

                <span class="btn-group" role="group">

                    <a class="nav-submenu" id="page-header-themes-dropdown-calendar" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="si si-home"></i>Calendar
                    </a>

                  <div class="dropdown-menu min-width-150" aria-labelledby="page-header-themes-dropdown-calendar" x-placement="top-start" style="position: absolute; transform: translate3d(0px, -11px, 0px); top: 0px; left: 0px; will-change: transform;">
 
                   <app-navbar-calendar></app-navbar-calendar>

                  </div>

                </span>
 
  
                <span class="btn-group" role="group">

                  <a class="nav-submenuX" data-toggle="nav-submenu" routerLink="/admin" *ngIf="userSvc.isAdmin">
                      <i class="si si-home"></i>Admin
                  </a>

                </span>
 
            </ul>

          </div>

        <div class="content-header-section float-right">

            <ul class="nav-main-header nav-main-header-no-icons">

            <div class="btn-group" role="group" *ngIf="userSvc.isLoggedIn()">
                <a   class="nav-submenu" id="page-header-user-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    {{userSvc.getUserName()}}
                </a>
                <div class="dropdown-menu dropdown-menu-right min-width-150" aria-labelledby="page-header-user-dropdown" x-placement="bottom-end" style="position: absolute; transform: translate3d(-128px, 34px, 0px); top: 0px; left: 0px; will-change: transform;">
                     

                    <a class="dropdown-item" (click)="logOut()">
                        <span><i class="si si-logout mr-5"></i> Sign Out</span>
                    </a>
                </div>
            </div>

            </ul>

          </div>
          <!-- END Right Section -->
        </div>



      </header>

      <!--
      <ul class="" *ngIf="userSvc.isLoggedIn() === false">
          <li><a routerLink="/login">Login</a></li>
          <li><a routerLink="/register">Register</a></li>
        </ul>
        <ul class=" " *ngIf="userSvc.isLoggedIn() === true">
            <li><a (click)="logOut()">Logout</a></li>
        </ul>

      -->
